<h3 mat-dialog-title>Transfer Pitch Work</h3>

  <div mat-dialog-content>
    <form [formGroup]="transferGroup">
  
      <mat-form-field class="card-dialog">
        <mat-label>From Pitch</mat-label>
        <mat-select id="from-pitch" matInput cdkTextareaAutosize formControlName="f_fromPitch" required>
          <mat-option *ngFor="let pitch of fromPitches" [value]="pitch.pitch_config_id">
            {{pitch.pitch_id}}<span *ngIf="pitch.type == 'subassembly'">&nbsp;({{pitch.subassembly_id}})</span>&nbsp;&nbsp;{{pitch.pitch_name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="card-dialog">
        <mat-label>From Variant</mat-label>
        <mat-select id="from-variant" matInput cdkTextareaAutosize formControlName="f_fromVariant" required>
          <mat-option *ngFor="let variant of fromPitchVariant" [value]="variant.variant_id">
            {{variant.variant_name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="card-dialog">
        <mat-label>To Pitch</mat-label>
        <mat-select id="to-pitch" matInput cdkTextareaAutosize  formControlName="f_toPitch" required>
          <mat-option *ngFor="let pitch of toPitches" [value]="pitch.pitch_config_id">
            {{pitch.pitch_id}}<span *ngIf="pitch.type == 'subassembly'">&nbsp;({{pitch.subassembly_id}})</span>&nbsp;&nbsp;{{pitch.pitch_name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="card-dialog">
        <mat-label>To Variant</mat-label>
        <mat-select id="to-variant" matInput cdkTextareaAutosize formControlName="f_toVariant" required>
          <mat-option *ngFor="let variant of toPitchVariant" [value]="variant.variant_id">
            {{variant.variant_name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
  
      
    </form>
  </div>
  
  <div *ngIf="workBeingDeletedWarning" class="warning-message">
    <span style="color: red;">WARNING: Existing work in 'To Pitch/Variant' will be deleted.</span>
  </div>
  
  <div *ngIf="samePitchVarSel" [style]="{'color': 'red', 'font-weight': 'bold', 'margin-bottom': '10px'}"> 
    Pitch Work cannot be transferred.
    From Pitch, Variant same as To Pitch, Variant.
  </div>
  
  <div *ngIf="waiting" class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
  
  <div mat-dialog-actions align="end">  
    <button [disabled]="!transferEnable || waiting" mat-raised-button color="primary" (click)="submitTransfer()">Submit</button>
    <span class="spacer"></span>
    <button mat-raised-button color="primary" (click)="onNoClick()">Close</button>
  
  </div>